import { useQuery } from "@tanstack/react-query";
import { fetchGeneralApiGet } from "../utils";
import type { AuthPermissionRules } from "./types";

export type {
  AuthInheritedScope,
  AuthPermissionRelationRules,
  AuthPermissionResourceRules,
  AuthPermissionRules,
  AuthPermissionScopeRules,
} from "./types";

export const authPermissionRulesQueryKey = ["general_api", "auth", "permissions", "rules"] as const;

export function getAuthPermissionRules() {
  return fetchGeneralApiGet<AuthPermissionRules>("auth/permissions/betterAuth/rules");
}

/** The server's permission catalog for client and non-client memberships. Static per deploy, so it isn't refetched on focus. */
export function useGetAuthPermissionRules() {
  return useQuery({
    queryKey: authPermissionRulesQueryKey,
    queryFn: async (): Promise<AuthPermissionRules> => {
      const response = await getAuthPermissionRules();
      if (!response.success) {
        throw new Error(response.message || "Unable to load permission rules");
      }
      return response.data;
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
